// Thin wrapper over react-router's useSearchParams that mirrors useState:
//
//   const [tab, setTab] = useUrlParam('tab', 'commanders');
//
// Reads the named query param (falling back to defaultValue) and
// writes via replaceState so typing in a search input doesn't bloat
// browser history. Setting back to the default value drops the param
// from the URL — keeps shared links short.

import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

export function useUrlParam(key, defaultValue = '') {
    const [searchParams, setSearchParams] = useSearchParams();
    const raw = searchParams.get(key);
    const value = raw == null ? defaultValue : raw;

    const setValue = useCallback(
        (next) => {
            setSearchParams(
                (prev) => {
                    const sp = new URLSearchParams(prev);
                    const isDefault =
                        next == null || next === '' || String(next) === String(defaultValue);
                    if (isDefault) sp.delete(key);
                    else sp.set(key, String(next));
                    return sp;
                },
                { replace: true }
            );
        },
        [key, defaultValue, setSearchParams]
    );

    return [value, setValue];
}
